import { Spinner } from '@iwoca/orion';
import { useLingui } from '@lingui/react/macro';

import styles from './CompanyLoading.module.css';
import { StepLayout } from '../../../StepLayout/StepLayout';

// DIT-681. Shown while the selected company's legal form is fetched.
export const CompanyLoading = () => {
  const { t } = useLingui();

  return (
    <StepLayout
      stageTitle={t`Business details`}
      heading={t`One moment…`}
      subHeading={t`We are fetching your company's data`}
      hideCta
    >
      <div className={styles.loading}>
        <Spinner />
      </div>
    </StepLayout>
  );
};
